import { HoverCard, Text } from "@mantine/core";
import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { CollectionQuery, Order } from "../../../models/collection.model";
import {
  EntityConfig,
  entityViewMode
} from "../../../models/entity-config.model";
import EntityList from "../../../shared/component/entity-list/entity-list.component";
import { useLazyGetCategoriesQuery } from "../store/category.query";
import { Category } from "../../../models/category.model";

export default function CategoryPage() {
  const params = useParams();
  const location = useLocation();
  const [viewMode, setViewMode] = useState<entityViewMode>("list");
  const [collection, setCollection] = useState<CollectionQuery>({
    skip: 0,
    top: 10,
    orderBy: [{ field: "createdAt", direction: "desc" }],
  });

  const [getCategories, categories] = useLazyGetCategoriesQuery();

  useEffect(() => {
    getCategories(collection);
  }, [collection]);

  useEffect(() => {
    if (params?.id !== undefined) {
      setViewMode("detail");
    } else {
      setViewMode("list");
    }
    if (location.pathname === "/user/archived") {
      setViewMode("detail");
    }
  }, [setViewMode, params?.id, location]);

  const data: Category[] | undefined = categories.data?.data;

  const config: EntityConfig<Category> = {
    primaryColumn: { key: "name", name: "Name" },
    detailUrl: "detail",
    rootUrl: "/settings-and-configurables/category",
    identity: "id",
    name: "name",
    visibleColumn: [
      { key: "name", name: "Name",render: (user) => {
        return (
          <Text size="sm" className={user?.deletedAt ? "text-danger" : ""}>
            {user.name}
          </Text>
        );
      } },
      {
        key: "description",
        name: "Description",
        render: (category: Category) => {
          
          return (
            <HoverCard width={280} shadow="md">
              <HoverCard.Target>
                <Text size="sm" className={"cursor-pointer"}>
                  {(category?.description && category?.description?.length > 25)
                    ? category?.description?.substring(0, 22) + "..."
                    : category?.description}
                </Text>
              </HoverCard.Target>
              <HoverCard.Dropdown
                className={"text-justify break-all wrap max-h-60 overflow-auto"}
              >
                <Text size="sm">{category.description}</Text>
               
              </HoverCard.Dropdown>
            </HoverCard>
          )
        },
      },
      {
        key: "archiveReason",
        name: "Archive Reason",
        hideSort: true,
        render: (category: Category) => {
          
          if(category.archiveReason){
            return (
              <HoverCard width={280} shadow="md">
                <HoverCard.Target>
                  <Text size="sm" className={"cursor-pointer"}>
                    {(category?.archiveReason && category?.archiveReason?.length > 25)
                      ? category?.archiveReason?.substring(0, 22) + "..."
                      : category?.archiveReason}
                  </Text>
                </HoverCard.Target>
                <HoverCard.Dropdown
                  className={"text-justify break-all wrap max-h-60 overflow-auto"}
                >
                  <Text size="sm">{category.archiveReason}</Text>
                 
                </HoverCard.Dropdown>
              </HoverCard>
            )
          }else{
            return "Not archived";
          }
          
        },
      },
      { key: "createdAt", name: "Registered At", isDate: true },
     
    ],
  };

  return (
    <div className="h-full p-4">
      <EntityList
        viewMode={viewMode}
        title={"Categories"}
        total={categories?.data?.count}
        itemsLoading={categories.isFetching}
        config={config}
        items={data}
        initialPage={1}
        defaultPageSize={10}
        pageSize={[10, 15, 20]}
        collectionQuery={collection}
        onArchivedChecked={(e) =>
          setCollection({
            ...collection,
            withArchived: e,
          })
        }
        onPaginationChange={(skip: number, top: number) => {
          if (collection.skip !== skip || collection.top !== top) {
            setCollection({ ...collection, skip: skip, top: top });
          }
        }}
        onSearch={(data: any) => {
          setCollection({
            ...collection,
            search: data,
            searchFrom: ["name"],
          });
        }}
        onFilterChange={(data: any) => {
          if(collection?.filter||data.length>0){
            setCollection({ ...collection, filter: data });
           }
        }}
        onOrder={(data: Order) =>
          setCollection({ ...collection, orderBy: [data] })
        }
      />
    </div>
  );
}
